import React from 'react';
import { Box, Button } from '@material-ui/core';
import InboxIcon from '@material-ui/icons/Inbox';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useAddToCart } from '../../../api/shoppingCart';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

const baseSize = 24;

const sizeMap: Record<string, number> = {
  BOX1: 18, // smallest
  BOX2: 22, // medium
  BOX3: 26, // biggest
  CTN: 24,
  PAL: 24,
};

const getIcon = (unit: string) => {
  const size = sizeMap[unit] || baseSize;

  const srcMap: Record<string, string> = {
    BOX1: '/pht/packageButtons/Box1.svg',
    BOX2: '/pht/packageButtons/Box2.svg',
    BOX3: '/pht/packageButtons/Box3.svg',
    CTN: '/pht/packageButtons/CTN.svg',
    PAL: '/pht/packageButtons/PAL.svg',
  };

  const src = srcMap[unit];

  if (!src) return <InboxIcon style={{ fontSize: baseSize }} />;

  return (
    <img
      src={src}
      alt={unit}
      style={{
        width: size,
        height: size,
        display: 'block',
      }}
      draggable={false}
    />
  );
};

type PackageButtonsProduct = {
  extra?: {
    measurementUnits?: {
      derivedUnit: string;
      quantity: number;
    }[];
  };
  id: string;
  sku: string;
};

type Props = {
  className?: string;
  product: PackageButtonsProduct;
};

export default function CataloguePageListContentItemPackageButtons({ product, className }: Props) {
  const { addToCart, quantity = 0 } = useAddToCart({
    product: {
      id: product.id,
      sku: product.sku,
    },
  });
  const t = useTranslateWithFallback();

  if (!product.extra?.measurementUnits?.length) return null;

  return (
    <Box className={className} display='flex' flexWrap='wrap' gridGap={8}>
      {product.extra.measurementUnits.map((unit) => (
        <Button
          key={unit.derivedUnit}
          size='small'
          variant='contained'
          onClick={() => addToCart(quantity + unit.quantity)}
          style={{
            backgroundColor: '#002969',
            color: 'white',
            minWidth: 56,
            maxWidth: 80,
            padding: '6px 8px',
            textTransform: 'none',
          }}
        >
          <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' lineHeight={1}>
            {/* Icon wrapper */}
            <Box position='relative' display='flex' alignItems='center' justifyContent='center'>
              {getIcon(unit.derivedUnit)}
              <AddCircleIcon
                style={{
                  fontSize: 14,
                  position: 'absolute',
                  top: -5,
                  right: -7,
                  color: '#f7d417',
                  backgroundColor: '#002969',
                  borderRadius: '50%',
                }}
              />
            </Box>

            {/* quantity */}
            <Box
              style={{
                fontSize: 11,
                marginTop: 3,
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {unit.quantity} {t('app/pcsInCartUnitPlural')}
            </Box>
          </Box>
        </Button>
      ))}
    </Box>
  );
}
